import React from 'react';
import PokemonList from '../Components/PokemonList';

function Pokemon() {
  return <PokemonList />;
}

export default Pokemon;
